'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dSignal from "./com.raquo.airstream.core.-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal from "./com.raquo.airstream.distinct.-Distinct-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_VarSignal(initial, parentDisplayName) {
  this.Fc = null;
  this.Fb = false;
  this.Fd = null;
  this.yT = 0;
  this.F9 = null;
  this.Fa = null;
  this.Fg = false;
  this.yU = null;
  this.Fe = null;
  this.Ff = 0;
  this.Fe = parentDisplayName;
  this.Fc = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.yT = 0;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.yU = (void 0);
  this.Ff = 1;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, initial);
}
export { $c_Lcom_raquo_airstream_state_VarSignal as $c_Lcom_raquo_airstream_state_VarSignal };
$p = $c_Lcom_raquo_airstream_state_VarSignal.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_VarSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_VarSignal() {
}
export { $h_Lcom_raquo_airstream_state_VarSignal as $h_Lcom_raquo_airstream_state_VarSignal };
$h_Lcom_raquo_airstream_state_VarSignal.prototype = $p;
$p.dP = (function() {
  return this.Fc;
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.Fb;
});
$p.fm = (function() {
  return this.Fd;
});
$p.ea = (function(x$1) {
  this.Fb = x$1;
});
$p.gD = (function(x$1) {
  this.Fd = x$1;
});
$p.ho = (function() {
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.gs = (function() {
  return this.yT;
});
$p.kI = (function(x$1) {
  this.yT = x$1;
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dSignal.$f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$p.hm = (function(observer) {
  observer.fY($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.ew = (function() {
  return this.F9;
});
$p.ey = (function() {
  return this.Fa;
});
$p.hw = (function() {
  return this.Fg;
});
$p.g1 = (function(x$1) {
  this.Fg = x$1;
});
$p.hf = (function(x$0) {
  this.F9 = x$0;
});
$p.hg = (function(x$0) {
  this.Fa = x$0;
});
$p.l3 = (function() {
  return this.yU;
});
$p.rb = (function(x$1) {
  this.yU = x$1;
});
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.dT = (function() {
  return this.Ff;
});
$p.id = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.hp = (function() {
});
$p.dd = (function() {
  return (this.Fe.h() + ".signal");
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_state_VarSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_VarSignal, "com.raquo.airstream.state.VarSignal", ({
  hn: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  c3: 1
}));
export { $d_Lcom_raquo_airstream_state_VarSignal as $d_Lcom_raquo_airstream_state_VarSignal };
